/**
 * Product Highlight Grid
 * Handles add to cart functionality for product cards and carousel slider initialization
 */

(function () {
  'use strict';

  function initProductHighlightGrid() {
    // Use event delegation on the document so dynamically-rendered cards also work
    if (document._addToBasketListenerAttached) return;
    document._addToBasketListenerAttached = true;

    document.addEventListener('click', function (e) {
      const button = e.target.closest('.js-add-to-basket');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      if (button.disabled || button.hasAttribute('data-sold-out')) return;

      const productId = button.getAttribute('data-product-id');
      const productUrl = button.getAttribute('data-product-url');

      if (!productId) {
        console.error('[product-highlight-grid] data-product-id missing');
        return;
      }

      const textEl = button.querySelector('.product-highlight-grid__add-to-basket-text');
      const originalText = textEl ? textEl.textContent : '';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // Resolve the cart drawer section ID for bundled rendering
      const cartDrawer = document.getElementById('cart-drawer');
      let sectionId = 'cart-drawer';
      if (cartDrawer) {
        const wrapper = cartDrawer.closest('[id^="shopify-section-"]');
        if (wrapper) sectionId = wrapper.id.replace('shopify-section-', '');
      }

      // Disable button and show loading state
      button.disabled = true;
      if (textEl) textEl.textContent = 'Adding…';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(productId, 10),
          quantity: 1,
          sections: sectionId,   // Request bundled cart-drawer HTML
        }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || err.message || 'Failed to add product to cart');
            });
          }
          return response.json();
        })
        .then(function (addData) {
          // cart/add.js returns section HTML but not the full cart totals —
          // fetch cart.js separately for item_count and total_price.
          return fetch(root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (textEl) textEl.textContent = 'Added to Cart';

              document.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                detail: {
                  cart: cart,
                  sections: addData.sections || null,
                },
              }));

              setTimeout(function () {
                if (textEl) textEl.textContent = originalText;
                button.disabled = false;
              }, 1500);
            });
        })
        .catch(function (error) {
          console.error('[product-highlight-grid] Error adding to cart:', error);
          if (textEl) textEl.textContent = 'Error';

          setTimeout(function () {
            if (textEl) textEl.textContent = originalText;
            button.disabled = false;
          }, 2000);

          // Redirect to product page if error requires variant selection
          if (productUrl) {
            setTimeout(function () { window.location.href = productUrl; }, 2000);
          }
        });
    });
  }

  var SLICK_RETRY_DELAY_MS = 100;
  var SLICK_MAX_RETRIES = 50;

  function initProductHighlightGridSlider(attempt) {
    attempt = attempt || 0;

    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      if (attempt >= SLICK_MAX_RETRIES) {
        return;
      }
      setTimeout(function () {
        initProductHighlightGridSlider(attempt + 1);
      }, SLICK_RETRY_DELAY_MS);
      return;
    }

    const $slider = jQuery('.js-product-highlight-grid-slider');

    if ($slider.length === 0) {
      return;
    }

    // Initialize slider on both mobile and desktop
    function initSlider() {
      // Destroy existing slider if it exists
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      // Initialize with responsive settings
      // Desktop: 2 slides with arrows, Mobile: 1 slide without arrows
      $slider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      });
    }

    // Initialize on load
    initSlider();

    // Re-initialize only when window width changes (with debounce)
    let resizeTimer;
    let lastWidth = jQuery(window).width();
    jQuery(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const currentWidth = jQuery(window).width();
        if (currentWidth !== lastWidth) {
          lastWidth = currentWidth;
          initSlider();
        }
      }, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductHighlightGrid();
      initProductHighlightGridSlider();
    });
  } else {
    initProductHighlightGrid();
    initProductHighlightGridSlider();
  }

  // Re-initialize on section load (for Theme Editor)
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId && document.querySelector('.section-product-highlight-grid')) {
      initProductHighlightGrid();
      initProductHighlightGridSlider();
    }
  });
})();
